export interface Master {
  address1?: string;
  address1m?: string;
  address1r?: string;
  address2?: string;
  address2m?: string;
  address2r?: string;
  attempt?: number;
  batchId?: number;
  campaignId?: number;
  clientNotes?: string;
  company?: string;
  completed?: boolean;
  country?: string;
  countrym?: string;
  dataFile?: number;
  dateImported?: Date;
  datetime?: Date;
  dpid?: string;
  dtUploaded?: Date;
  email1?: string;
  email2?: string;
  fax?: string;
  first?: string;
  inBatch?: boolean;
  last?: string;
  mobile?: string;
  notes?: string;
  outcome?: string;
  phone1?: string;
  phone2?: string;
  position?: string;
  postcode?: string;
  postcodem?: string;
  postcoder?: string;
  recordId?: number;
  result?: string;
  sal?: string;
  sessionId?: string;
  smsBlocked?: boolean;
  source?: string;
  state?: string;
  statem?: string;
  stater?: string;
  stickyNotes?: string;
  suburb?: string;
  suburbm?: string;
  suburbr?: string;
  u1?: string;
  u10?: string;
  u11?: string;
  u12?: string;
  u13?: string;
  u14?: string;
  u15?: string;
  u16?: string;
  u17?: string;
  u18?: string;
  u19?: string;
  u2?: Date;
  u20?: string;
  u3?: string;
  u4?: string;
  u5?: string;
  u6?: string;
  u7?: string;
  u8?: string;
  u9?: string;
  voiceBlocked?: boolean;
  web?: string;
}

export type MasterValidation = {
  [key in keyof Master]: { maxLength: number };
};

export const masterValidation: MasterValidation = {
  address1: { maxLength: 80 },
  address1m: { maxLength: 50 },
  address1r: { maxLength: 50 },
  address2: { maxLength: 80 },
  address2m: { maxLength: 50 },
  address2r: { maxLength: 50 },
  company: { maxLength: 80 },
  country: { maxLength: 50 },
  countrym: { maxLength: 50 },
  dpid: { maxLength: 50 },
  email1: { maxLength: 50 },
  email2: { maxLength: 50 },
  fax: { maxLength: 50 },
  first: { maxLength: 50 },
  last: { maxLength: 50 },
  mobile: { maxLength: 50 },
  phone1: { maxLength: 50 },
  phone2: { maxLength: 50 },
  position: { maxLength: 50 },
  postcode: { maxLength: 50 },
  postcodem: { maxLength: 50 },
  postcoder: { maxLength: 50 },
  result: { maxLength: 50 },
  sal: { maxLength: 50 },
  sessionId: { maxLength: 50 },
  source: { maxLength: 50 },
  state: { maxLength: 50 },
  statem: { maxLength: 50 },
  stater: { maxLength: 50 },
  stickyNotes: { maxLength: 75 },
  suburb: { maxLength: 50 },
  suburbm: { maxLength: 50 },
  suburbr: { maxLength: 50 },
  u1: { maxLength: 50 },
  u10: { maxLength: 50 },
  u11: { maxLength: 50 },
  u12: { maxLength: 50 },
  u13: { maxLength: 50 },
  u14: { maxLength: 50 },
  u15: { maxLength: 50 },
  u16: { maxLength: 50 },
  u17: { maxLength: 50 },
  u18: { maxLength: 50 },
  u19: { maxLength: 50 },
  u20: { maxLength: 50 },
  u3: { maxLength: 50 },
  u4: { maxLength: 50 },
  u5: { maxLength: 50 },
  u6: { maxLength: 50 },
  u7: { maxLength: 50 },
  u8: { maxLength: 50 },
  u9: { maxLength: 50 },
  web: { maxLength: 50 },
};
